import ContentClient from './ContentClient';

export class CustomContentClient extends ContentClient {
    constructor(httpClient, baseContentURL, secureContentURL = '', assessmentShortName = '') {
        super(httpClient);

        this.constructor.BASE_URL = baseContentURL;
        this.constructor.FORMS_URL = `${baseContentURL}/forms`;
        this.constructor.CUTSCORES_URL = `${baseContentURL}/cutscores`;
        this.constructor.SECURE_FORMS_URL = secureContentURL;
        this.constructor.ASSESSMENT_SHORT_NAME = assessmentShortName;
    }
}

export default CustomContentClient;
